import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-632710ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Multiple Settings")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Delete selected ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Move selected ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-move-folder" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
    onHide: _ctx.hidePopUp,
    "hide-bottom-decoration": "",
    "hide-top-decoration": ""
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.deleteAll }, {
        icon: _withCtx(() => [
          _hoisted_3
        ]),
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      (!_ctx.hideMoveTo)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 0,
            onClick: _ctx.moveAll
          }, {
            icon: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onHide"]))
}